module.exports = __webpack_public_path__ + "static/eseller1000-e772a0d5b2e106ed9596eec192becc40.png";